import { render, staticRenderFns } from "./Materrialpicture.vue?vue&type=template&id=d1a21da8&scoped=true&"
import script from "./Materrialpicture.vue?vue&type=script&lang=js&"
export * from "./Materrialpicture.vue?vue&type=script&lang=js&"
import style0 from "./Materrialpicture.vue?vue&type=style&index=0&id=d1a21da8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a21da8",
  null
  
)

export default component.exports